import React, { Component } from 'react';

//componentes
import Recepcion from './recepcion'

class Index extends Component {

    render(){
        return(
            <div>
                <Recepcion />
            </div>
        );
    }

}
export default Index;